import { DecimalPipe, UpperCasePipe } from '@angular/common';
import { Component, Input, ViewChild } from '@angular/core';
import { TranslocoModule } from '@jsverse/transloco';
import {
  QaiCardTitleButtonComponent,
  QaiCardTitleComponent,
  QaiDialogComponent,
  QaiLinkButtonComponent,
  QaiResultCardComponent,
  QaiScoreComponent,
  QaiScoresListComponent,
  QaiSlotDirective,
} from '@qai/ui';
import { IScoreOverallConversational } from 'src/app/interfaces/iscore-overall-conversational';
import { ScoreArrayItem } from 'src/app/utils/enums/result/resultConversational.enum';
import { splitBoldAndRegularText } from 'src/app/utils/html-parser.util';

@Component({
  selector: 'app-result-overall-score',
  standalone: true,
  imports: [
    DecimalPipe,
    UpperCasePipe,
    TranslocoModule,
    QaiScoresListComponent,
    QaiScoreComponent,
    QaiCardTitleComponent,
    QaiCardTitleButtonComponent,
    QaiLinkButtonComponent,
    QaiSlotDirective,
    QaiResultCardComponent,
    QaiDialogComponent,
  ],
  templateUrl: './result-overall-score.component.html',
  styleUrls: ['./result-overall-score.component.scss'],
})
export class ResultOverallScoreComponent {
  @Input() scoresArray: ScoreArrayItem[] = [];
  @Input() scoreOverall: IScoreOverallConversational | undefined;

  @ViewChild('dialog') qaiDialogRef: QaiDialogComponent | undefined;

  get isWeightAvg(): boolean {
    return this.scoresArray.length > 1;
  }

  handleOnClickHowIsCalculated() {
    this.qaiDialogRef?.showModal();
  }

  parseBold(text: string): { boldText: string; restText: string } {
    return splitBoldAndRegularText(text);
  }
}
